/* hz-halloween.js  -  Histozing Halloween sections (Minimog OS 2.0)
   Hand-written, NOT generated: the preview's JS only built cards from a JS
   array, and here Liquid renders them server-side.

   Everything is scoped to .hzhw blocks and re-runs on the theme editor's
   section:load event, so a merchant dragging a section in the Customize screen
   gets working carousels and counters without a reload. */
(function () {
  'use strict';

  var ROOT = '.hzhw';

  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------- toast */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'hzhw hzhw-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('hzhw-is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('hzhw-is-on'); }, 2200);
  }

  /* ---------------------------------------------------------- carousel */
  function initCarousel(root) {
    all('.hzhw-crow', root).forEach(function (row) {
      var next = row.querySelector('.hzhw-crow__next');
      var track = row.querySelector('.hzhw-crow__track');
      if (!next || !track || next.dataset.hzBound) return;
      next.dataset.hzBound = '1';
      next.addEventListener('click', function () {
        var first = track.firstElementChild;
        /* step one card PLUS the gap, so a click always lands on a card edge */
        var gap = parseFloat(getComputedStyle(track).columnGap || '20') || 20;
        var step = first ? first.getBoundingClientRect().width + gap : 300;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        track.scrollBy({ left: atEnd ? -track.scrollWidth : step, behavior: 'smooth' });
        row.classList.add('hzhw-is-on');
      });
      /* The mobile scroll hint - a faded chevron over the right edge - retires
         itself once the row has actually moved. A hint you have already taken
         is just something in the way. `once` because this otherwise fires on
         every frame of a fling. */
      track.addEventListener('scroll', function () {
        if (track.scrollLeft > 8) row.classList.add('hzhw-is-on');
      }, { passive: true, once: true });
    });
  }

  /* ---------------------------------------------------------- stats
     setTimeout, not requestAnimationFrame, and a plain scroll listener rather
     than an IntersectionObserver: both of those are verifiable in a headless
     preview pane, which rAF and IO are not. */
  function commas(v) { return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function initStats(root) {
    all('.hzhw-stats__grid', root).forEach(function (grid) {
      if (grid.dataset.hzBound) return;
      grid.dataset.hzBound = '1';
      grid.dataset.hzDone = '';
    });
  }
  function runStats() {
    all('.hzhw-stats__grid').forEach(function (grid) {
      if (grid.dataset.hzDone) return;
      if (grid.getBoundingClientRect().top > window.innerHeight - 80) return;
      grid.dataset.hzDone = '1';
      var els = all('[data-hz-to]', grid);
      var t0 = Date.now(), DUR = 1600;
      (function step() {
        var k = Math.min(1, (Date.now() - t0) / DUR);
        var e = 1 - Math.pow(1 - k, 3);
        els.forEach(function (el) {
          var to = parseFloat(el.getAttribute('data-hz-to')) || 0;
          el.textContent = (el.getAttribute('data-hz-pre') || '') +
            commas(Math.round(to * e)) + (el.getAttribute('data-hz-suf') || '');
        });
        if (k < 1) setTimeout(step, 40);
      })();
    });
  }

  /* ---------------------------------------------------------- countdown
     The target date rides on the element, so the merchant sets it in the theme
     editor and nothing in here changes. Parsed as LOCAL end-of-day on purpose:
     a bare '2026-10-31' is read as UTC midnight, which puts the clock out by
     the better part of a day for half the planet. */
  function initCountdown(root) {
    all('[data-hz-cd]', root).forEach(function (box) {
      if (box.dataset.hzBound) return;
      box.dataset.hzBound = '1';
      var end = new Date(box.getAttribute('data-hz-cd') + 'T23:59:59');
      if (isNaN(end)) return;
      var cell = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { cell[k] = box.querySelector('[data-cd="' + k + '"]'); });
      if (!cell.d) return;
      function p(v) { return (v < 10 ? '0' : '') + v; }
      function beat() {
        var ms = end - new Date();
        if (ms <= 0) {
          box.classList.add('hzhw-is-over');
          var lead = box.querySelector('.hzhw-hbanner__cd-lead');
          if (lead) lead.textContent = box.getAttribute('data-hz-cd-over') || '';
          clearInterval(box.__hzT);
          return;
        }
        var t = Math.floor(ms / 1000);
        cell.d.textContent = Math.floor(t / 86400);
        cell.h.textContent = p(Math.floor(t % 86400 / 3600));
        cell.m.textContent = p(Math.floor(t % 3600 / 60));
        cell.s.textContent = p(t % 60);
      }
      beat();
      box.__hzT = setInterval(beat, 1000);
    });
  }

  /* ---------------------------------------------------------- reveal */
  function reveal() {
    var vh = window.innerHeight;
    all('.hzhw-rev:not(.hzhw-is-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh - 60) el.classList.add('hzhw-is-in');
    });
  }

  /* ---------------------------------------------------------- press-hold zoom
     Touch only. The flag is read on the card's own click rather than by
     swallowing clicks globally, so a stuck flag can only cost one card tap. */
  var holdT = null, holdCard = null;
  function releaseHold() {
    clearTimeout(holdT);
    if (holdCard) holdCard.classList.remove('hzhw-is-zoom');
    holdCard = null;
  }
  document.addEventListener('pointerdown', function (e) {
    window.__hzHeld = false;
    if (e.pointerType === 'mouse') return;
    var c = e.target.closest('.hzhw-card, .hzhw-pcard');
    if (!c) return;
    holdCard = c;
    holdT = setTimeout(function () {
      if (holdCard) { holdCard.classList.add('hzhw-is-zoom'); window.__hzHeld = true; }
    }, 280);
  });
  document.addEventListener('pointerup', releaseHold);
  document.addEventListener('pointercancel', releaseHold);
  document.addEventListener('pointermove', function () {
    if (holdCard && !holdCard.classList.contains('hzhw-is-zoom')) releaseHold();
  });

  /* ---------------------------------------------------------- clicks */
  document.addEventListener('click', function (e) {
    /* The card is a link now. The only thing to catch is a press-and-hold
       that was a zoom and not a tap - without this, every zoom on a phone
       ends up on the product page. */
    if (e.target.closest('.hzhw-card, .hzhw-pcard') && window.__hzHeld) {
      window.__hzHeld = false;
      e.preventDefault();
      return;
    }
    if (e.target.closest('[data-hz-toast]')) {
      toast(e.target.closest('[data-hz-toast]').getAttribute('data-hz-toast'));
    }
  });

  /* ---------------------------------------------------------- boot */
  function initAll(scope) {
    all(ROOT, scope && scope.querySelector ? scope : document).forEach(function (root) {
      initCarousel(root);
      initStats(root);
      initCountdown(root);
    });
    if (scope && scope.matches && scope.matches(ROOT)) {
      initCarousel(scope); initStats(scope); initCountdown(scope);
    }
    reveal();
    runStats();
  }

  function onScroll() { reveal(); runStats(); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: a section re-rendered by Customize has no listeners yet. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function () { onScroll(); });
})();
